'use client';

export default function ProjectFooterSkeleton() {
  return (
    <div className="flex flex-col animate-pulse">
      <div className="flex space-x-8">
        {/* Avatar */}
        <div className="avatar">
          <div className="w-20 rounded-full bg-gray-300"></div>
        </div>

        {/* Title */}
        <div className="flex flex-col space-y-4">
          <div className="h-6 w-56 bg-gray-300 rounded" />
          <div className="flex space-x-2">
            <div className="border-[1px] border-semitrans p-3 w-24"></div>
            <div className="border-[1px] border-semitrans p-3 w-24"></div>
          </div>
        </div>
      </div>

      {/* bottom */}
      <div className="w-full my-4 border-t-[1px] border-semitrans" />
      <div className="flex flex-col space-y-2">
        <div className="w-full bg-gray-300 h-4" />
        <div className="w-full bg-gray-300 h-4" />
        <div className="w-96 bg-gray-300 h-4" />
      </div>
    </div>
  );
}
